import { ajaxCall, formRequestData } from './ajaxService';

const constants = window.getConfig;
const ajaxPurchaseOrdersHistoryUrl = `${constants.ajax.baseUrl}/purchaseorders/history`;

export const ajaxGetPurchaseOrdersHistoryByPo = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      let url = ajaxPurchaseOrdersHistoryUrl + `/po/${params.PurchaseOrderId}`;
      ajaxCall(url, formRequestData(constants.ajax.methods.get, true))
        .then(res)
        .catch(rej);
    } else {
      throw new Error('Purchase order ID is required');
    }
  });

  export const ajaxGetPurchaseOrderHistory = (params) =>
    new Promise((res, rej) => {
      if (params && params.PurchaseOrderHistoryId) {
        let url = ajaxPurchaseOrdersHistoryUrl + `/${params.PurchaseOrderHistoryId}`;
        ajaxCall(url, formRequestData(constants.ajax.methods.get, true))
          .then(res)
          .catch(rej);
      } else {
        throw new Error('Purchase order ID is required');
      }
    });
